import React from 'react';
import { Form } from 'react-bootstrap';
import { MdCancel, MdDelete, MdEdit, MdSave, MdOutlineSave  } from "react-icons/md";
import DimensionsService from '../services/DimensionsService';
import { AccountRoles } from './AccountRoles';


interface EditUserRoleProps {
    dimension: string;
    account: string;
    email: string;
    userRole: AccountRoles;
    isOnlyOneAdmin: boolean;
    onUserPermissionsUpdate: (userPermissions: any) => void;
}

const EditUserRole: React.FC<EditUserRoleProps> = ({
    dimension,
    account,
    email,
    userRole,
    isOnlyOneAdmin,
    onUserPermissionsUpdate
}) => {
    const [role, setRole] = React.useState<AccountRoles>(userRole);
    const [isEditing, setIsEditing] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [isRoleChanged, setIsRoleChanged] = React.useState(false);

    React.useEffect(() => {
        setRole(userRole);
    }, [userRole]);

    const updateUserRole = async () => {
        if(!window.confirm(`Are you sure you want to change the role for the user with email ${email}?`)){
            return;
        }
        try {
            const userPermissions = await DimensionsService.setUserPermissions(dimension, account, role);
            setIsEditing(false);
            onUserPermissionsUpdate(userPermissions);
            setErrorMessage('');
        } catch (error) {
            setErrorMessage(`Failed to update role: ${error}`);
        }
    };

    const toggleEdit = () => {
        setIsEditing(!isEditing);
        setIsRoleChanged(role !== userRole);
    };

    const cancelEdit = () => {
        setIsEditing(false);
        setRole(userRole); 
    };

    const removeUserHandler = async () => {
        if (!window.confirm(`Are you sure you want to remove the user with email ${email}?`)) {
            return;
        }
        try {
            const userPermissions = await DimensionsService.removeUserPermissions(dimension, account);
            onUserPermissionsUpdate(userPermissions);
            setErrorMessage('');
        } catch (error) {
            setErrorMessage(`Failed to remove user: ${error}`);
        }
    };
    
    const handleRoleChange = (e: any) => {
        const newRole = e.target.value as AccountRoles;
        setRole(newRole);
        setIsRoleChanged(newRole !== userRole); 
    };

    return (
        <>
        <div style={{ width: '100%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
 
                <Form.Control
                    type="text"
                    disabled
                    value={email || "Invalid user"}
                    style={{ border: 'none', backgroundColor: 'transparent', flexGrow: 1 }}
                />
                <Form.Control
                    as="select"
                    value={role}
                    onChange={handleRoleChange}
                    disabled={!isEditing}
                    style={{ border: 'none', backgroundColor: 'transparent', textAlign: 'center', width: '100px' }}
                >
                    { Object.values(AccountRoles).map((role) => (
                        <option key={role} value={role}>{role}</option>
                    ))}
                </Form.Control>
                {email && !isOnlyOneAdmin && (
                    <button style={{ border: 'none', background: 'none' }} 
                        onClick={() => (isEditing ? updateUserRole() : toggleEdit())}
                        disabled={!isRoleChanged && isEditing}>
                        {isEditing 
                            ? (isRoleChanged ? <MdSave size={24} color="blue" /> : <MdOutlineSave size={24} color="blue" />) 
                            : <MdEdit size={24} color="blue" />
                        }
                    </button>
                )}
                {isEditing && (
                    <button style={{ border: 'none', background: 'none' }} onClick={cancelEdit}>
                        <MdCancel size={24} color="gray" />
                    </button>
                )}
                {!isOnlyOneAdmin && ( 
                    <button style={{ border: 'none', background: 'none' }} onClick={removeUserHandler}>
                        <MdDelete size={24} color="red" />
                    </button>
                )}
            </div>
                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
        </div>
           
        </>
    );
};

export default EditUserRole;
